import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import { getExternalContent } from 'utils/externalContentApi'
import { Loading } from '../Hangouts/Loading'
import { AccessDenied } from './AccessDenied'

function ContentViewer({ repository }) {
  const { id } = useParams()
  const [externalContent, setExternalContent] = useState(null)
  const [loading, setLoading] = useState(false)
  const [externalContentError, setExternalContentError] = useState({
    title: '',
    text: '',
  })

  useEffect(() => {
    let mounted = true
    const checkEntity = async () => {
      setExternalContentError({ title: '', text: '' })
      setLoading(true)
      try {
        const data = await getExternalContent(id, repository)

        if (mounted && !data.error) {
          setLoading(false)
          setExternalContent(data)
        } else {
          switch (data.error?.response?.status) {
            case 404:
              setExternalContentError(
                {
                  title: 'Não foi possível acessar o Conteúdo Digital',
                  text: 'Você não tem permissão para acessar esse conteúdo. Para saber o motivo entre em contato com sua escola.',
                },
              )
              break
            case 500:
              setExternalContentError(
                {
                  title: 'Não foi possível solicitar sua requisição',
                  text: 'Para saber o motivo entre em contato com sua escola.',
                },
              )
              break
            default:
              throw new Error('')
          }
        }
      } catch (e) {
        setLoading(false)
          setExternalContentError(
            {
              title: 'Não foi possível solicitar sua requisição',
              text: 'Para saber o motivo entre em contato com sua escola.',
            },
          )
          setExternalContent(null)
      }
    }
    checkEntity()
    return () => {
      mounted = false
    }
  }, [id, repository])


  if (externalContent && externalContent.type === 'redirect') {
    window.location.href = externalContent.url
  }

  if (externalContentError.title) {
    return <AccessDenied {...externalContentError} />
  }

  return (
    <>
      {loading && <Loading message='Estamos carregando seu conteúdo' />}
      {externalContent && externalContent.type === 'embed' &&
        <iframe
          allowFullScreen
          src={externalContent.url}
          style={{ overflow: 'hidden', overflowX: 'hidden', overflowY: 'hidden', height: '100%', width: '100%', position: 'absolute', top: '0px', left: '0px', right: '0px', bottom: '0px' }}
          width='100%'
          height='100%'
          id={`open-${id}`}
          title='External Content'
        />}
    </>
          )
}

ContentViewer.propTypes = {
  repository: PropTypes.string,
}

export default ContentViewer
